import { Box } from "@hightouch/htui";

// Pointer events pass through to the card, whose click handler also takes this button's keyboard clicks as they bubble.
export const EntityCardOpen = ({ name }: { name: string }) => (
  <Box
    as="button"
    type="button"
    aria-label={`Open ${name}`}
    position="absolute"
    inset={0}
    zIndex={1}
    borderRadius="xl"
    pointerEvents="none"
    outline="none"
    _focusVisible={{ boxShadow: "outline" }}
  />
);
